<script>
  import { Link } from "svelte-navigator";
  import { onMount } from "svelte";
  import Button from '../components/Button.svelte';
  import Modal from '../components/Modal.svelte';
  import ArrowRight from "../assets/images/icon-arrow-right.svelte";
  import InfoIcon from "../assets/images/icon-info.svelte";
  import Fer from "../Fer.js";

  const LogsArray = [
    '/assets/images/LogStack/logs-0.svg',
    '/assets/images/LogStack/logs-1.svg',
    '/assets/images/LogStack/logs-2.svg',
    '/assets/images/LogStack/logs-3.svg',
    '/assets/images/LogStack/logs-4.svg',
    '/assets/images/LogStack/logs-5.svg',
    '/assets/images/LogStack/logs-6.svg',
  ];

  let isShownInfo;
  const setIsShownInfo = bool => {
    isShownInfo = bool;
  };
  const touch = () => {
    if (isShownInfo) {
      setIsShownInfo(false);
    } else {
      setIsShownInfo(true);
    }
  };

  let video_input;
  let elem;
  let anim, animApi;
  let fer;

  let gameStarted = false;
  let introModalVisible = true;
  let outroModalVisible = false;

  // game
  // constants
  const y_step = 60;
  const x_step = 400;

  const x_min = -100;
  const x_max = 100;
  const y_min = -100;
  const y_max = 75;

  // falling log
  const log_min = 0;
  const log_max = 100;
  const log_step = 600;
  const reset_delay = 1; // in milli second

  let faceControl = "neutral"

  let sawjoystick_x = x_max
  let sawjoystick_y = y_min
  let logslider = log_min
  let log_falling = false
  let reset = 0
  let score = 0;
  const max_score = 6;

  // timings
  let last_frame = 0;
  let every_x_frame = 2;
  let framerate_count = 0;
  const delta_m = 50

  function updateLoop() {
    if(gameStarted) {
      const this_frame = performance.now() / 1000;
      const dt = this_frame - last_frame
      last_frame = this_frame

      if (faceControl === 'scream') {
        // push to the left
        sawjoystick_x -= dt * x_step;
        if (sawjoystick_x <= x_min) {
          // cannot push any further
          sawjoystick_x = x_min;
        } else {
          // if can push to the left also move down
          sawjoystick_y += dt * y_step;
        }
      } else if (faceControl === 'smile') {
        // push to the right
        sawjoystick_x += dt * x_step;
        if (sawjoystick_x >= x_max) {
          // cannot push any further
          sawjoystick_x = x_max;
        } else {
          // if can push to the right also move down
          sawjoystick_y += dt * y_step;
        }
      }

      // saw reached bottom of log
      if (sawjoystick_y >= y_max) {
        // cannot move further down
        // using +0.1 such that this is only called once
        sawjoystick_y = y_max + 0.1;
        log_falling = true;
      }

      // let log fall down
      if (log_falling) {
        logslider += dt * log_step;
        if (logslider >= log_max) {
          // cannot fall further and reset
          log_falling = false;
        }
      }

      // reset after some time log has reached ground
      if (logslider > log_max) {
        reset += dt;
        if (reset > reset_delay) {
          sawjoystick_x = x_max
          sawjoystick_y = y_min
          logslider = log_min
          reset = 0
          log_falling = false
          score += 1

          if (score >= max_score) {
            gameStarted = false;
            outroModalVisible = true;
          }

          }
        }
    }
    requestAnimationFrame(updateLoop);
  }

  function animloaded(e) {
    console.log("loaded");

    animApi = lottie_api.createAnimationApi(anim);
    let log = animApi.getKeyPath("SawSlider,Transform,X Position");
    let saw = animApi.getKeyPath("JoyStkCtrlSaw,Transform,Position");
    animApi.addValueCallback(log, function(currentValue) {
      return logslider;
    });
    animApi.addValueCallback(saw, function(currentValue) {
      return [sawjoystick_x, sawjoystick_y];
    });
  }

  const startGame = () => {
    gameStarted = true;
    introModalVisible = false;
    outroModalVisible = false;
  };

  const playAgain = () => {
    score = 0;
    startGame();
  };

  onMount(() => {
    const cam = new Camera(video_input, {
      facingMode: 'user',
      width: 1280,
      height: 720,
      onFrame: async () => {
        if(framerate_count % every_x_frame == 0) {
          faceControl = await fer.getExpression(video_input, 1280, 720)
        }
        framerate_count += 1;
      }
    });

    fer = Fer.getInstance()
    fer.setupTf().then(() => {
      cam.start()
    })

    anim = lottie.loadAnimation({
      container: elem,
      path: "/lotties/saw.json",
      renderer: "svg",
      loop: true,
      autoplay: true
    });

    anim.addEventListener("DOMLoaded", animloaded);
    console.log("before updateLoop")
    updateLoop();
  });
</script>

<div class='saw '>
  <div class='saw__content'>
    <div class='saw__shed sshed'>
      <div class='saw__wrapper--shed'>
        <img src='/assets/images/shed.svg' alt='i2' />
      </div>
    </div>
    <main class='saw__main smain'>
      <div class='saw__wrapper'>
        <div class='saw__wrapper--saw'>
          <div bind:this={elem}></div>
        </div>
        <div class='saw__wrapper--logs '>
          <img class='logs' src={ LogsArray[score] } alt='i1' />
        </div>
      </div>
      <Link to='/games'>
        <button class='btn-arrow'>
          <ArrowRight />
        </button>
      </Link>
    </main>
  </div>

  <footer class='saw__footer'>
    <div class='saw__footer--camera'>
      <div class='cam'>
        <video
          class='camera'
          style="transform: scaleX(-1);"
          bind:this={ video_input }
        >
          <track kind="captions" srclang="en" label="english_captions">
        </video>
      </div>
    </div>
    <div class='info__expression flex flex-ai-c scale'>
      <img src='/emojis/anger.png' alt='Anger emoji' />
      <div class='info__expression--text  '>
        <h5>ANGER</h5>
        <h2>to Saw Backwards</h2>
      </div>
    </div>
    <div class='info__expression flex flex-ai-c scale '>
      <img src='/emojis/smile.png' alt='Smile emoji' />
      <div class='info__expression--text  '>
        <h5>SMILE</h5>
        <h2>to Saw Forwards</h2>
      </div>
    </div>
    <div class='saw__footer--score'>
      <span>{ score }</span>
    </div>
  </footer>
  <Link to='/games'>
    <button class='btn-arrow'>
      <ArrowRight />
    </button>
  </Link>
  <button
    on:mouseleave={() => setIsShownInfo(false)}
    on:mouseenter={() => setIsShownInfo(true)}
    on:touchstart={() => touch()}
    class='btn-info'
  >
    <InfoIcon />
  </button>

  {#if introModalVisible}
    <Modal hasHeader={true}>
      <div slot="header">Task</div>
      <div class="flowers__modaltext" slot="content">
        <h4>Saw 6 logs</h4>
      </div>
      <div class="flowers__hero--btn" slot="buttons">
        <Button
          buttonSize="btn--xlarge"
          buttonStyle="btn--primary--solid"
          on:click={() => startGame()}
        >
          PLAY
        </Button>
      </div>
    </Modal>
  {/if}

  {#if outroModalVisible}
    <Modal hasHeader={true}>
      <div slot="header">Task Complete</div>
      <div class="flowers__modaltext" slot="content">
        <h4>SAW-esome!</h4>
      </div>
      <div class="flowers__hero--btn" slot="buttons">
        <Button
          buttonSize="btn--xlarge"
          buttonStyle="btn--primary--solid"
          on:click={() => playAgain()}
        >
          PLAY AGAIN
        </Button>
        <Link to="/games">
          <Button
            buttonSize="btn--xlarge"
            buttonStyle="btn--primary--solid"
          >
            MENU
          </Button>
        </Link>
      </div>
    </Modal>
  {/if}

  <div>
    {#if isShownInfo}
      <div class='info'>
        <h4>Saw 6 logs</h4>
        <div class='info__expression flex flex-ai-c '>
          <img src='/emojis/anger.png' alt='Anger emoji' />
          <div class='info__expression--text  '>
            <h5>ANGER</h5>
            <h2>to Saw Backwards</h2>
          </div>
        </div>
        <div class='info__expression flex flex-ai-c '>
          <img src='/emojis/smile.png' alt='Smile emoji' />
          <div class='info__expression--text  '>
            <h5>SMILE</h5>
            <h2>to Saw Forwards</h2>
          </div>
        </div>
        <p> <strong>Note:</strong> The facial detection is not perfect. Play in good lighting conditions and try with variations of your facial expressions.</p>
      </div>
    {/if}
  </div>  
</div>